import React, { useState, useMemo, useRef } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { withStyles, Tooltip, IconButton, Typography } from '@material-ui/core';
import { hasPermission, createHistory, hasAtLeastOnePermission } from '../../sc-utilities';
import DeviceCasePreselectionList from './DeviceCasePreselectionList';
import {  AssessmentOutlined, FindInPage } from '@material-ui/icons';

const styles = theme => ({
    root: {
        width: `98.9%`,
        height: 'auto',
        paddingLeft: theme.spacing(),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            width: '100%'
        }
    },
    "@global": {
        "[class*='statusActive']": {
            color: theme.palette.success.dark
        },
        "[class*='statusInactive']": {
            color: theme.palette.error.dark
        }
    },
    statusActive: {
        color: theme.palette.success.dark
    },
    statusInactive: {
        color: theme.palette.error.dark
    }
});

const productTypeLookup = (translations) => {
    return {
        "work": translations["work"] || "Work",
        "mobile": translations["mobile"] || "Mobile",
        "watch": translations["watch"] || "Watch",
        "headphone": translations["headphone"] || "Headphone"
    }
}

const DeviceCasePreselection = props => {
    const tableRef = useRef();
    const { classes, columns, translations, permissions } = props;
    const [redirectOptions, setRedirectOptions] = useState({ redirect: false, deviceCasePreselectionID: null, redirectPath: '' });
    
    const isAdminView = window.location.href.includes('/admin');

    const redirectPath = isAdminView ? '/admin/device-case-preselection/' : '/settings/device_case_preselection/';

    const loadPreselectionPermission = isAdminView ? hasPermission(permissions, 'system_device_case_preselection_load') : hasAtLeastOnePermission(permissions, ['system_device_case_preselection_load', 'device_case_preselection_load'])

    const productTypeLookups = productTypeLookup(translations)

    let visible = columns && columns['DeviceCasePreselection'];
    const tableColumns = useMemo(() => {
        return [
            {
                title: translations["actions"] || "Actions", field: 'Actions',
                hidden: visible ? visible['Actions'] : false,
                cellStyle: { minWidth: 30, maxWidth: 50 },
                filtering: false,
                render: rowData => <>
                    {
                        loadPreselectionPermission ? <Tooltip title={translations["device_case_preselection_details"] || "Device case preselection details"}>
                            <IconButton value={rowData.DeviceCasePreselectionID} aria-label={translations["device_case_preselection_details"] || "Device case preselection details"} onClick={() => redirectHandler(`${redirectPath}update?deviceCasePreselectionID=${rowData.DeviceCasePreselectionID}`, rowData.DeviceCasePreselectionID)}>
                                <FindInPage />
                            </IconButton>
                        </Tooltip> : ''
                    }
                    {
                        <Tooltip title={translations["list_diagnose_cases"] || "List diagnose cases"}>
                            <IconButton value={rowData.DeviceCasePreselectionID} aria-label={translations["list_diagnose_cases"] || "List diagnose cases"} onClick={() => redirectHandler(`${redirectPath}diagnose?deviceCasePreselectionID=${rowData.DeviceCasePreselectionID}&Name=${rowData.Name}`, rowData.DeviceCasePreselectionID)}>
                                <AssessmentOutlined />
                            </IconButton>
                        </Tooltip>
                    }
                </>
            },
            {
                title: translations["name"] || 'Name', field: 'Name',
                hidden: visible ? visible['Name'] : false,
                filtering: true,
                render: rowData => {
                    return <Typography variant={'caption'}>{rowData.Name ?? (translations['short_not_assigned'] || 'n/a')}</Typography>;
                }
            },
            {
                title: translations["product_type"] || 'Product type', field: 'ProductType',
                hidden: visible ? visible['ProductType'] : false,
                filtering: true,
                filterCellStyle: { maxWidth: '150px' },
                lookup: productTypeLookups,
                defaultFilter: Object.keys(productTypeLookups),
                render: rowData => {
                    return <Typography variant={'caption'}>{rowData.ProductType ? translations[rowData.ProductType] || rowData.ProductType : (translations['short_not_assigned'] || 'n/a')}</Typography>;
                }
            },
            {
                title: translations["type"] || 'Type', field: 'Type',
                hidden: visible ? visible['Type'] : false,
                filtering: true,
                lookup: { 'system': translations["system"] || 'System', 'custom': translations["custom"] || 'Custom' },
                defaultFilter: ['system', 'custom'],
                render: rowData => {
                    return <Typography variant={'caption'}>{!rowData.CustomerID ? translations["system"] || 'System' : translations["custom"] || 'Custom'}</Typography>;
                }
            },
        ];
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [classes, translations, visible])

    const redirectHandler = (path, deviceCasePreselectionID = null) => {
        createHistory();
        setRedirectOptions({ redirect: true, deviceCasePreselectionID: deviceCasePreselectionID, redirectPath: path });
    };

    if (redirectOptions.redirect) {
        return <Redirect
            to={{
                pathname: redirectOptions.redirectPath.split('?')[0], search: redirectOptions.redirectPath.split('?')[1],
                state: { redirectOptions }
            }}
        />;
    }

    return (
        <div className={classes.root}>
            {hasPermission(permissions, 'device_case_preselection_list') ?
                <DeviceCasePreselectionList
                    tableColumns={tableColumns}
                    redirectHandler={redirectHandler}
                    tableRef={tableRef}
                    isAdminView={isAdminView}
                />
                :
                null}
        </div>
    );
};

const mapStateToProps = state => {
    return {
        translations: state?.translate?.translations?.activeTranslations || {},
        columns: state?.core?.login?.userSettings?.Columns || null,
        permissions: state?.core?.login?.permissions || []
    };
};

export default connect(
    mapStateToProps,
    null
)(withStyles(styles)(DeviceCasePreselection));